/**
 * An accordion component that animates open and close
 * General structure
 * <hh-accordion>
 *  <a class="js-trigger"></a>
 *  <div class="js-content motion" style="display: none;"></div>
 * </hh-accordion>
 *
 * the `isDesktopList` property is for instances where the elemment is
 * an accordion on mobile but an opened list on desktop (ex. the footer)
 */

import { utils } from '@hh/global.js'

const { isDesktop, debounce, prefersReducedMotion } = utils
class HHAccordion extends HTMLElement {
  constructor() {
    super()

    this.trigger = this.querySelector(':scope > .js-accordion-trigger')
    this.toShow = this.querySelector(':scope > .js-accordion-content')
    this.isDesktopList = this.dataset.isDesktopList
    this.isMobileMenu = this.dataset.isMobileMenu

    this.isInitialOpen = this.hasAttribute('open')
    if (this.isInitialOpen) {
      this.toggle()
    }

    this.handleResize = this.handleResize.bind(this)
    this.trigger?.addEventListener('click', this.toggle.bind(this))
    this.toShow?.addEventListener(
      'transitionend',
      this.handleTransitionEnd.bind(this)
    )

    if (this.isDesktopList) {
      this.handleResize()
      window.addEventListener('resize', debounce(this.handleResize, 200), {
        passive: true,
      })
    }
  }

  toggle(e) {
    if (e) {
      e.preventDefault()
    }

    this.trigger.setAttribute('aria-expanded', !this._isOpen)

    this._isOpen ? this.close() : this.open()
    this._isOpen = !this._isOpen
  }

  handleTransitionEnd() {
    if (!this._isOpen) {
      this.toShow.style.display = 'none'
    }
  }

  open() {
    this.toShow.style.removeProperty('display')
    this.toShow.style.maxHeight = (this.toShow.scrollHeight + 30) + 'px'
    if (this.isMobileMenu) {
      // Close any adjacent open accordions
      this.closest('ul')?.querySelectorAll('.js-accordion-content.open').forEach((openAccordionContent) => {
        openAccordionContent.closest('hh-accordion')?.toggle()
      })
    }
    setTimeout(() => {
      this.toShow.classList.add('open')
    }, 0)
  }

  close() {
    this.toShow.classList.remove('open')
    this.toShow.style.maxHeight = null

    // the `handleTransitionEnd` function doesn't fire if `prefers-reduced-motion`
    // is on, so it needs to be be called on its own
    if (prefersReducedMotion()) {
      this.toShow.style.display = 'none'
    }
  }

  handleResize() {
    if (isDesktop() && this.isDesktopList) {
      this.toShow.style.removeProperty('display')
      this.trigger.removeAttribute('aria-expanded')
    }
  }
}

customElements.define('hh-accordion', HHAccordion)
